import ActionsHistoryContainer from './actions-history-container';

export default ActionsHistoryContainer;
